import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { Observable } from 'rxjs';
import { FaqsService } from 'src/app/services/faqs.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {


  loadingPage: boolean = false;

  @ViewChild('containerEvents', { static: false }) containerEvents: ElementRef;
  loadingLottie: AnimationOptions = {
    path: 'assets/lotties/loading.json',
  };

  @ViewChild(MatAccordion) accordion: MatAccordion;
  faqs: Observable<any[]>;

  isNotProfile = false;

  constructor(
    private faqService: FaqsService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.router.url === '/faqs') {
      this.isNotProfile = true;
    }
    this.loadingPage = true;
    this.faqService.getAllFAQs().subscribe((resp) => {
      this.faqs = resp;
      this.loadingPage = false;
    }, error => {
      this.loadingPage = false;
      console.error('Error loading FAQs:', error);
    });
  }

  backTab() {
    this.router.navigate(['/profile']);
  }

}
